<template>
  <div>
  <div class="row">
    <div class="col-xl-8 m-t offset-xl-2">
      <div class="card">
        <div class="card-body pb-0">
          <div class="text-value text-center text-success"><h1><i class="fa fa-check"></i><br/>Obrigado pelo seu pedido!</h1></div>
        </div>
        <b-row class="m-t padder">
          <b-col md="4" offset-md="4">
            <div class="card">
              <div class="card-body text-center">
                <p>Se optou pelo pagamento em boleto, envie o comprovante para contato@sleeker.pt e agilize sua ativação!</p>
              </div>
            </div>
          </b-col>
        </b-row>
        <b-row style="justify-content: center">
          <b-button variant="info" @click="backToSleeker()" type="button" style="margin-bottom: 4px">
            <span class="text-white">Ir para o Sleeker</span>
          </b-button>
        </b-row>
        <br />
      </div>
    </div>
    </div>
  </div>
   


 

</template>

<script>

export default {
  name: "PaymentSuccess",
  data() {
    return {

    };
  },
  methods: {
    backToSleeker: function () {
      this.$router.push({ name: 'Busca', params: { page: 1 }});
    }
  },
  created() {
    let existingTrackingData = undefined;

    if (localStorage.trackingData) {
      existingTrackingData = JSON.parse(localStorage.trackingData);
    }

    if (!existingTrackingData) {
      existingTrackingData = {};
    }
    
    gtag('event', 'conversion', {
      'send_to': 'AW-722097690/-IxNCOqQ07gBEJqsqdgC',
      'transaction_id': ''
    });
    
    existingTrackingData["successPagseguro"] = true;
    

    localStorage.trackingData = JSON.stringify(existingTrackingData);
  }
};

</script>